






















































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { ReportFilter, ReportParameter } from "@/entities";
import LeftNavigationComponent from "../Workspace/Components/LeftNavigation.vue";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { Locales } from "@/i18n/locales";
import Axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {
    AdvanceSearchComponent,
    LeftNavigationComponent
  },
})
export default class AllocationReportComponent extends Vue {
  items: any = [];
  data: any = [];
  subIndicators: any = [];
  reportedLevels: any = [];
  sites: any = [];
  programms: any = [];
  selectedPath: any = "";
  search: string = "";
  activeNodes: any = [];
  showSideBar: boolean = false;
  isLoading: boolean = false;

  selectedKey: string = Object.keys(this.subSections.properties)[0];
  fields: Array<ReportFilter> = [];
  selectedParams: Array<ReportParameter> = [];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  refReport: string = "reportDataTable";
  headers: any = [
    { text: "Initiative", value: "Initiative", sortable: false },
    { text: "Region", value: "Region", sortable: false },
    { text: "Country", value: "Country", sortable: false },
    { text: "Grant Type", value: "GrantType", sortable: false },
    { text: "Project Title", value: "ProjectTitle", sortable: false },
    { text: "Period", value: "Title", sortable: false },
    { text: "Budgeted", value: "Forecast", align: 'right', sortable: false },
    { text: "Actual", value: "Spent", align: 'right', sortable: false }
  ];

  mounted() {
    this.$services.allocationReport.getFilters().then((resp: any) => {
      this.fields = resp;
    });
  }

  // generate the report
  generateReport() {
    this.data = [];
    this.isLoading = true;
    this.$services.allocationReport
      .generateReport(this.selectedParams)
      .then((resp: any) => {
        this.isLoading = false;
        this.data = resp.data;
      });
  }

  sidebarToggle() {
        this.showSideBar = !this.showSideBar;
    }

  /** Return budget reports */
    get subSections() {
        return _app.budgetReportSections;
    }

  _btnExport() {
    let expotableItems: any = [];
    let defaultSheetName = "Sheet1";
    let defaultFileName = "Report";

    let expotableFields = this.headers.map(({ value, text }) => ({
      value,
      text,
    }));

    // @ts-ignore
    let filteredItems = this.$refs[this.refReport].$children[0].filteredItems;

    // Select items with exportable true
    expotableItems = filteredItems.map((o) =>
      expotableFields.reduce((acc, curr) => {
        acc[curr.text] = curr.value in o ? o[curr.value] : "";
        return acc;
      }, {})
    );

    let fileName = `${defaultFileName}_${moment().format("DD-MM-YYYY")}`;

    // Export to excel
    if (expotableItems) {
      var sheet1 = XLSX.utils.json_to_sheet(expotableItems);
      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, sheet1, defaultSheetName);
      XLSX.writeFile(wb, `${fileName}.csv`);
    }
  }
}
